import { getTranslationManually } from "src/helpers/locale";

export const ACCOUNT_TYPE_VALUES = {
  PERSONAL: 1,
  BUSINESS: 2,
  COMPANY: 3
};

export const businessEntitiesOptions = [
  { value: "perseorangan", label: "page-business-type.form.business-entities.perseorangan" },
  { value: "pt", label: "page-business-type.form.business-entities.pt" },
  { value: "pt_perorangan", label: "page-business-type.form.business-entities.pt_perorangan" },
  { value: "cv", label: "page-business-type.form.business-entities.cv" },
  { value: "yayasan", label: "page-business-type.form.business-entities.yayasan" },
  { value: "bmt", label: "page-business-type.form.business-entities.bmt" },
  { value: "koperasi", label: "page-business-type.form.business-entities.koperasi" },
  { value: "bpr", label: "page-business-type.form.business-entities.bpr" },
  { value: "bprs", label: "page-business-type.form.business-entities.bprs" },
  { value: "bank", label: "page-business-type.form.business-entities.bank" },
  { value: "pjp", label: "page-business-type.form.business-entities.pjp" },
  { value: "firma", label: "page-business-type.form.business-entities.firma" },
  { value: "perguruan_tinggi", label: "page-business-type.form.business-entities.perguruan_tinggi" },
  { value: "kementerian", label: "page-business-type.form.business-entities.kementerian" },
  { value: "lembaga_pemerintahan", label: "page-business-type.form.business-entities.lembaga_pemerintahan" },
  { value: "badan_usaha_pemerintah", label: "page-business-type.form.business-entities.badan_usaha_pemerintah" }
];

export const volumeOptions = [
  // { value: 1, label: "page-business-type.form.volume.low" },
  // { value: 2, label: "page-business-type.form.volume.mid" },
  // { value: 3, label: "page-business-type.form.volume.high" },
  { value: 4, label: "page-business-type.form.volume.max-four-hundred" },
  { value: 5, label: "page-business-type.form.volume.max-a-thousand" },
  { value: 6, label: "page-business-type.form.volume.max-three-thousand" },
  { value: 7, label: "page-business-type.form.volume.max-five-thousand" },
  { value: 8, label: "page-business-type.form.volume.max-ten-thousand" },
  { value: 9, label: "page-business-type.form.volume.more-than-ten-thousand" }
];

export const monthlyTPVOptions = [
  { value: "10", label: "page-business-type.form.monthly-tpv.less-than-20-million" },
  { value: "11", label: "page-business-type.form.monthly-tpv.between-20-and-149-million" },
  { value: "12", label: "page-business-type.form.monthly-tpv.between-150-and-4000-million" },
  { value: "13", label: "page-business-type.form.monthly-tpv.more-than-4000-million" }
];

export const OPTIONS_TYPE = {
  PROVINCE: "province",
  CITY: "city",
  INDUSTRY: "industry",
  SERVICE_TYPE: "serviceTypeOptions"
};

export const SERVICE_TYPE_VALUES = {
  MONEY_TRANSFER: 1,
  ACCEPT_PAYMENT: 2,
  INTERNATIONAL_TRANSFER: 3
};

export const SERVICE_TYPE_PREFIX = {
  [SERVICE_TYPE_VALUES.MONEY_TRANSFER]: "MT",
  [SERVICE_TYPE_VALUES.ACCEPT_PAYMENT]: "AP",
  [SERVICE_TYPE_VALUES.INTERNATIONAL_TRANSFER]: "IT"
};

export const SERVICE_TYPE_TEXT = {
  [SERVICE_TYPE_VALUES.MONEY_TRANSFER]: "money-transfer",
  [SERVICE_TYPE_VALUES.ACCEPT_PAYMENT]: "receive-money",
  [SERVICE_TYPE_VALUES.INTERNATIONAL_TRANSFER]: "international-transfer"
};

export const serviceTypeOptions = [
  {
    value: SERVICE_TYPE_VALUES.MONEY_TRANSFER,
    label: "page-business-type.form.service-type.send-money",
    tooltip: "page-business-type.form.tooltip"
  },
  {
    value: SERVICE_TYPE_VALUES.ACCEPT_PAYMENT,
    label: "page-business-type.form.service-type.accept-payment",
    tooltip: "page-business-type.form.tooltip"
  },
  {
    value: SERVICE_TYPE_VALUES.INTERNATIONAL_TRANSFER,
    label: "page-business-type.form.service-type.international",
    tooltip: "page-business-type.form.tooltip"
  }
];

export const platformSelectionTypeOptions = [
  { value: 1, label: "" },
  { value: 2, label: "page-business-type.form.service-type.integration" }
];

export const purposeOfUseSending = [
  "page-business-type.form.usage-purpose.send.sending-salary-payment",
  "page-business-type.form.usage-purpose.send.sending-vendors",
  "page-business-type.form.usage-purpose.send.sending-company-needs"
];

export const purposeOfUseReceiving = [
  "page-business-type.form.usage-purpose.receive.receive-donations",
  "page-business-type.form.usage-purpose.receive.receive-education-donations",
  "page-business-type.form.usage-purpose.receive.receive-member-funds",
  "page-business-type.form.usage-purpose.receive.receive-company-services"
];

export const OTHER_PURPOSE_OPTION = {
  send: {
    value: `${SERVICE_TYPE_PREFIX[SERVICE_TYPE_VALUES.MONEY_TRANSFER]}: other`,
    label: "page-business-type.form.usage-purpose.other-purpose-send"
  },
  receive: {
    value: `${SERVICE_TYPE_PREFIX[SERVICE_TYPE_VALUES.ACCEPT_PAYMENT]}: other`,
    label: "page-business-type.form.usage-purpose.other-purpose-receive"
  },
  sendAbroad: {
    value: `${SERVICE_TYPE_PREFIX[SERVICE_TYPE_VALUES.INTERNATIONAL_TRANSFER]}: other`,
    label: "page-business-type.form.usage-purpose.other-purpose-send-it"
  }
};

export const IDENTITY_TYPE = {
  KTP: "ktp",
  PASSPORT: "paspor"
};

export const identityOptions = [
  { value: IDENTITY_TYPE.KTP, label: "page-personal-data.options.identity-type.e-ktp" },
  { value: IDENTITY_TYPE.PASSPORT, label: "page-personal-data.options.identity-type.passport" }
];

export const jobOptions = [
  { value: "housewife", label: "page-personal-data.options.job.housewife" },
  { value: "enterpreneur", label: "page-personal-data.options.job.enterpreneur" },
  { value: "private_employee", label: "page-personal-data.options.job.private_employee" },
  { value: "government_employee_echelon", label: "page-personal-data.options.job.government_employee_echelon" },
  { value: "government_employee_not_echelon", label: "page-personal-data.options.job.government_employee_not_echelon" },
  { value: "state_officials", label: "page-personal-data.options.job.state_officials" },
  { value: "political_party_member", label: "page-personal-data.options.job.political_party_member" },
  { value: "foundation_member", label: "page-personal-data.options.job.foundation_member" },
  { value: "freelancer", label: "page-personal-data.options.job.freelancer" },
  { value: "migrant_worker", label: "page-personal-data.options.job.migrant_worker" },
  { value: "others", label: "page-personal-data.options.job.others" }
];

export const CHANNEL_VALUE = {
  WEBSITE: "website",
  APPLICATION: "application",
  MARKETPLACE: "marketplace",
  MEDSOC: "medsoc",
  FACEBOOK: "facebook",
  TWITTER: "twitter",
  INSTAGRAM: "instagram",
  WHATSAPP: "whatsapp"
};

export const channelOptions = [
  {
    label: "page-business-details.form.options.channel.website",
    value: CHANNEL_VALUE.WEBSITE
  },
  {
    label: "page-business-details.form.options.channel.facebook",
    value: CHANNEL_VALUE.FACEBOOK
  },
  {
    label: "page-business-details.form.options.channel.twitter",
    value: CHANNEL_VALUE.TWITTER
  },
  {
    label: "page-business-details.form.options.channel.instagram",
    value: CHANNEL_VALUE.INSTAGRAM
  },
  {
    label: "page-business-details.form.options.channel.application",
    value: CHANNEL_VALUE.APPLICATION
  }
];

export const CHANNEL_ADDRESS_INPUT = {
  [CHANNEL_VALUE.WEBSITE]: { prefix: "", placeholder: "https://" },
  [CHANNEL_VALUE.FACEBOOK]: { prefix: "facebook.com/", placeholder: "username" },
  [CHANNEL_VALUE.TWITTER]: { prefix: "x.com/", placeholder: "username" },
  [CHANNEL_VALUE.INSTAGRAM]: { prefix: "instagram.com/", placeholder: "username" },
  [CHANNEL_VALUE.WHATSAPP]: { prefix: "wa.me/", placeholder: "628123456789" },
  [CHANNEL_VALUE.APPLICATION]: { prefix: "", placeholder: "https://" }
};

export const orderFlowOptions = {
  [CHANNEL_VALUE.WEBSITE]: [
    {
      label: "page-business-details.form.options.product-sold.website.way-1",
      value: 1
    },
    {
      label: "page-business-details.form.options.product-sold.website.way-2",
      value: 2
    },
    {
      label: "page-business-details.form.options.product-sold.website.way-3",
      value: 3
    }
  ],
  [CHANNEL_VALUE.APPLICATION]: [
    {
      label: "page-business-details.form.options.product-sold.application.way-1",
      value: 1
    },
    {
      label: "page-business-details.form.options.product-sold.application.way-2",
      value: 2
    }
  ],
  [CHANNEL_VALUE.FACEBOOK]: [
    {
      label: "page-business-details.form.options.product-sold.facebook.way-1",
      value: 1
    },
    {
      label: "page-business-details.form.options.product-sold.facebook.way-2",
      value: 2
    },
    {
      label: "page-business-details.form.options.product-sold.facebook.way-3",
      value: 3
    }
  ],
  [CHANNEL_VALUE.TWITTER]: [
    {
      label: "page-business-details.form.options.product-sold.twitter.way-1",
      value: 1
    },
    {
      label: "page-business-details.form.options.product-sold.twitter.way-2",
      value: 2
    },
    {
      label: "page-business-details.form.options.product-sold.twitter.way-3",
      value: 3
    }
  ],
  [CHANNEL_VALUE.INSTAGRAM]: [
    {
      label: "page-business-details.form.options.product-sold.instagram.way-1",
      value: 1
    },
    {
      label: "page-business-details.form.options.product-sold.instagram.way-2",
      value: 2
    },
    {
      label: "page-business-details.form.options.product-sold.instagram.way-3",
      value: 3
    }
  ]
};

export const offlineOrderFlowOptions = [
  {
    label: "page-business-details.form.options.product-sold.offline.way-1",
    value: 1
  },
  {
    label: "page-business-details.form.options.product-sold.offline.way-2",
    value: 2
  },
  {
    label: "page-business-details.form.options.product-sold.offline.way-3",
    value: 3
  }
];

export const businessTypeOptions = [
  {
    value: "2",
    label: "page-resubmission.form.clarification.company_details.business-type.options.individual.title",
    description: "page-resubmission.form.clarification.company_details.business-type.options.individual.description"
  },
  {
    value: "3",
    label: "page-resubmission.form.clarification.company_details.business-type.options.legal-entity.title",
    description: "page-resubmission.form.clarification.company_details.business-type.options.legal-entity.description"
  }
];

export const OPTIONS_CONFIRMATION = [
  { value: true, label: getTranslationManually("Ya", "Yes") },
  { value: false, label: getTranslationManually("Tidak", "No") }
];

export const ACCESIBILITY_WEB_STATUS = {
  VALID: "valid",
  INVALID: "invalid",
  TIMEOUT: "timeout"
};

export const CHANNELS_PREFIX = {
  [CHANNEL_VALUE.FACEBOOK]: "facebook.com/",
  [CHANNEL_VALUE.TWITTER]: "x.com/",
  [CHANNEL_VALUE.INSTAGRAM]: "instagram.com/"
};
